// extracted by mini-css-extract-plugin
export var subtitle = "_cj-2";
export var title = "_cj-0";
export var titleNoWrap = "_cj-1";